/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme-dark/base/colors";
import typography from "assets/theme-dark/base/typography";
import borders from "assets/theme-dark/base/borders";

// Material Dashboard 2 PRO React Helper Functions
import rgba from "assets/theme-dark/functions/rgba";

const { info, inputBorderColor } = colors;
const { size } = typography;
const { borderWidth } = borders;

const input = {
  styleOverrides: {
    root: {
      fontSize: size.sm,
      color: "var(--app-field-text)",

      "&:hover:not(.Mui-disabled):before": {
        borderBottom: `${borderWidth[1]} solid ${rgba(inputBorderColor, 0.6)}`,
      },

      "&:before": {
        borderColor: rgba(inputBorderColor, 0.6),
      },

      "&:after": {
        borderColor: info.main,
      },

      "& input, & textarea, & .MuiInputBase-input, & .MuiInput-input": {
        color: "var(--app-field-text)",
        WebkitTextFillColor: "var(--app-field-text)",
        caretColor: "var(--app-field-text)",
      },

      "& input::placeholder, & textarea::placeholder, & .MuiInputBase-input::placeholder, & .MuiInput-input::placeholder": {
        color: "var(--app-field-placeholder)",
        opacity: 1,
      },

      "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & textarea:-webkit-autofill, & textarea:-webkit-autofill:hover, & textarea:-webkit-autofill:focus": {
        WebkitTextFillColor: "var(--app-field-text)",
        caretColor: "var(--app-field-text)",
        WebkitBoxShadow: "0 0 0 1000px var(--app-field-bg) inset",
      },
    },
  },
};

export default input;
